/* ================================================================
   J.REDD THEME · v4.5 — CART CONTRACT ACCEPTANCE
   Requires the customer to accept the J.Redd Licensing Agreement before
   checkout whenever the cart contains a Lease or Premium Lease license.
   Works theme-wide (the AJAX cart drawer is this theme's cart interface) and is
   self-contained: it reads the existing local cart, gates the existing checkout
   button, and drives the global cart licensing modal. No other behavior changes.
================================================================ */
(function () {
  'use strict';

  // The local cart (source of truth for the drawer) stores each line's chosen
  // license tier in `licenseKey`. Lease + Premium require the agreement;
  // Exclusive is an inquiry flow (it never reaches Shopify checkout).
  var CART_KEY = 'jredd_cart_v1';
  var LICENSED_TIERS = { lease: true, premium: true };

  function readCart() {
    try {
      var raw = localStorage.getItem(CART_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function tiersInCart() {
    var t = {};
    readCart().forEach(function (c) {
      if (c && c.licenseKey) t[String(c.licenseKey).toLowerCase()] = true;
    });
    return t;
  }
  function requiresContract() {
    var t = tiersInCart();
    return !!(t.lease && LICENSED_TIERS.lease) || !!(t.premium && LICENSED_TIERS.premium);
  }

  var contract    = document.getElementById('cartContract');
  var checkbox    = document.getElementById('cartContractCheckbox');
  var errorMsg    = document.getElementById('cartContractError');
  var checkoutBtn = document.getElementById('btnCheckout');

  // ---- Conditional display + checkout enabled/blocked state ---------------
  function syncCheckoutState() {
    if (!checkoutBtn) return;
    var blocked = requiresContract() && checkbox && !checkbox.checked;
    checkoutBtn.classList.toggle('is-blocked', blocked);
    checkoutBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
  }
  function updateVisibility() {
    if (contract) {
      var need = requiresContract();
      contract.hidden = !need;
      if (!need && errorMsg) errorMsg.hidden = true;
    }
    syncCheckoutState();
  }

  if (checkbox) {
    checkbox.addEventListener('change', function () {
      if (checkbox.checked && errorMsg) errorMsg.hidden = true;
      syncCheckoutState();
    });
  }

  function blockCheckout() {
    if (errorMsg) errorMsg.hidden = false;
    if (contract) {
      contract.classList.remove('cart-contract--shake');
      void contract.offsetWidth; // restart animation
      contract.classList.add('cart-contract--shake');
    }
    if (checkbox) { try { checkbox.focus(); } catch (e) {} }
  }

  // Enforce on the drawer checkout button. Capture phase runs BEFORE theme.js's
  // own click handler, and stopImmediatePropagation prevents the redirect.
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      if (requiresContract() && checkbox && !checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        blockCheckout();
      }
    }, true);
  }

  // Safety net for any other checkout control (e.g. a standard cart-page form),
  // so the rule holds on every cart interface the theme might use.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[name="checkout"], [data-checkout], button[formaction*="/checkout"], input[formaction*="/checkout"]');
    if (!t || t.id === 'btnCheckout') return;
    if (requiresContract() && checkbox && !checkbox.checked) {
      e.preventDefault();
      e.stopImmediatePropagation();
      blockCheckout();
    }
  }, true);

  // ---- Re-evaluate whenever the cart changes ------------------------------
  // theme.js re-renders the drawer body on every cart mutation.
  var cartBody = document.getElementById('cartBody');
  if (cartBody && 'MutationObserver' in window) {
    new MutationObserver(updateVisibility).observe(cartBody, { childList: true, subtree: true });
  }
  // Re-check when the drawer is opened from any entry point.
  document.addEventListener('click', function (e) {
    if (e.target.closest('#cartIcon, #v18StickyCart')) setTimeout(updateVisibility, 0);
  });

  /* ================================================================
     LICENSING AGREEMENT MODAL (accessible)
  ================================================================ */
  var modal     = document.getElementById('cartLicenseModal');
  var modalBody = document.getElementById('cartLicenseBody');
  var lastFocus = null;

  function revealRelevantTiers() {
    if (!modalBody) return;
    var t = tiersInCart();
    var anyShown = false;
    var sections = modalBody.querySelectorAll('.cart-license-tier');
    Array.prototype.forEach.call(sections, function (sec) {
      var show = !!t[sec.getAttribute('data-tier')];
      sec.hidden = !show;
      if (show) anyShown = true;
    });
    if (!anyShown) { // fallback — show everything
      Array.prototype.forEach.call(sections, function (sec) { sec.hidden = false; });
    }
  }
  function focusable() {
    if (!modal) return [];
    var nodes = modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(nodes, function (el) {
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
  }
  function isOpen() { return modal && modal.classList.contains('open'); }
  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    revealRelevantTiers();
    modal.classList.add('open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('v3-modal-lock');
    if (modalBody) modalBody.scrollTop = 0;
    var f = focusable();
    (f[0] || modalBody || modal).focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('v3-modal-lock');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-license-open]');
    if (opener) { e.preventDefault(); e.stopPropagation(); openModal(); return; }
    var closer = e.target.closest('[data-cart-license-close]');
    if (closer && isOpen()) { e.preventDefault(); closeModal(); }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); closeModal(); return; }
    if (e.key === 'Tab') {
      var f = focusable();
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (modal && !modal.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
  });

  /* ================================================================
     v4.6 — /cart COMPATIBILITY HAND-OFF
     The /cart bridge template (sections/main-cart.liquid) redirects Shopify-
     generated cart links (Order Status, Customer Accounts, emails) to
     `{{ root }}?cart=open`. When that flag is present, open the EXISTING cart
     drawer via the existing window.JREDD.openCart API once the theme has booted
     (after the loading screen hides). No cart state is read or copied here —
     the drawer renders from the same single cart it always has.
  ================================================================ */
  (function () {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
    if (params.get('cart') !== 'open') return;

    // Clean the flag from the URL so refresh/share doesn't re-open the drawer.
    try {
      params.delete('cart');
      var qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
    } catch (e) {}

    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      var loadScreen = document.getElementById('loading');
      var booted = !loadScreen || loadScreen.classList.contains('hidden');
      if (booted && window.JREDD && typeof window.JREDD.openCart === 'function') {
        clearInterval(poll);
        window.JREDD.openCart();
      } else if (tries > 80) { // ~12s safety stop
        clearInterval(poll);
      }
    }, 150);
  })();

  // ---- Init ----------------------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateVisibility);
  } else {
    updateVisibility();
  }
})();
